<dx-box height="100%" width="100%" direction="col">
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <dx-data-grid
                width="100%"
                height="100%"
                [showBorders]="true"
                [showRowLines]="true"
                [showColumnLines]="true"
                [wordWrapEnabled]="true"
                [allowColumnResizing]="true"
                [dataSource]="selectedExpenseTabDatail"
            >
                <dxo-sorting mode="none"></dxo-sorting>

                <dxi-column
                    [width]="100"
                    dataType="date"
                    dataField="date"
                    caption="Date"
                    [format]="dateFormat"
                ></dxi-column>
                <dxi-column [width]="250" dataType="string" dataField="description" caption="Description"></dxi-column>
                <dxi-column [width]="100" dataType="string" dataField="isBillable" caption="Billable"></dxi-column>
                <ng-container *ngIf="selectedTab.name === 'timeExpense'">
                    <dxi-column
                        [width]="100"
                        dataType="string"
                        dataField="billingCode"
                        caption="Billing Code"
                    ></dxi-column>
                    <dxi-column [width]="100" dataType="number" dataField="duration" caption="Duration (hr)">
                        <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                    </dxi-column>
                </ng-container>
                <ng-container *ngIf="selectedTab.name === 'mileageExpense'">
                    <dxi-column
                        [width]="200"
                        dataType="string"
                        dataField="beginMileage"
                        caption="Begin Mileage"
                    ></dxi-column>
                    <dxi-column
                        [width]="200"
                        dataType="string"
                        dataField="endMileage"
                        caption="End Mileage"
                    ></dxi-column>
                    <dxi-column [width]="100" dataType="number" dataField="milesDriven" caption="Miles Driven">
                        <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                    </dxi-column>
                </ng-container>
                <dxi-column
                    [width]="120"
                    dataType="number"
                    dataField="amount"
                    caption="Amount"
                    [format]="currencyFormat"
                ></dxi-column>
                <dxi-column
                    [width]="120"
                    dataType="number"
                    dataField="reimbursableAmount"
                    caption="Reimbursable Amount"
                    [format]="currencyFormat"
                ></dxi-column>
                <dxi-column
                    [width]="100"
                    dataType="boolean"
                    dataField="notes"
                    caption="Notes"
                    cellTemplate="notesCellTemplate"
                ></dxi-column>

                <div *dxTemplate="let cell of 'notesCellTemplate'">
                    <div class="cc-hyperlink" (click)="onNotesClick(cell.data)">
                        <i *ngIf="!!cell.value" class="cc-1-5x cc-icon-check" [ngClass]="iconNotes"></i>
                        <i *ngIf="!cell.value" class="cc-1-5x cc-blue-icon" [ngClass]="iconEmptyNotes"></i>
                    </div>
                </div>

                <dxo-summary [calculateCustomSummary]="calculateCustomSummary">
                    <dxi-total-item
                        column="amount"
                        summaryType="custom"
                        alignment="right"
                        dataType="number"
                        displayFormat="Total: {0}"
                        [valueFormat]="currencyFormat"
                    ></dxi-total-item>
                    <dxi-total-item
                        column="reimbursableAmount"
                        summaryType="custom"
                        alignment="right"
                        dataType="number"
                        displayFormat="Total: {0}"
                        [valueFormat]="currencyFormat"
                    ></dxi-total-item>
                </dxo-summary>
            </dx-data-grid>
        </div>
    </dxi-item>
</dx-box>

<dx-popup
    *ngIf="notesVisible"
    minWidth="150px"
    minHeight="150px"
    width="60%"
    height="50%"
    title="Notes"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [showCloseButton]="true"
    [closeOnOutsideClick]="false"
    [visible]="notesVisible"
    (onShown)="onShown($event)"
    (onHidden)="onNotesPopClose()"
>
    <div *dxTemplate="let data of 'content'">
        <app-notes-editor
            [previousNotes]="selectedExpense.notes"
            [previousNotesVisible]="true"
            (onNotesPopUpClose)="onNotesPopClose()"
            (onNewNotesSave)="onSaveNotes($event)"
        ></app-notes-editor>
    </div>
</dx-popup>
